import React from 'react'
import { Container } from 'react-bootstrap'

function FaqScreen() {
  return (
    <Container className="py-4">
      <h2 className="ws-section-title">Frequently Asked Questions</h2>
      <h5>What wig types do you offer?</h5>
      <p className="ws-muted">We carry full lace, lace front, human hair, and synthetic wigs in multiple styles and lengths.</p>
      <h5>How do I choose the right length and style?</h5>
      <p className="ws-muted">Use our Filters to explore by style (straight, curly, wavy, body wave) and length. Product pages include fit and care tips.</p>
      <h5>Can I return a wig?</h5>
      <p className="ws-muted">For hygiene reasons, only unopened, unworn wigs in original packaging are eligible within the return window.</p>
      <h5>Do you ship internationally?</h5>
      <p className="ws-muted">Yes. Shipping options and fees are shown at checkout based on destination.</p>
      <h5>How are prices shown?</h5>
      <p className="ws-muted">Prices display in the currency saved with the product. Sale items show the original price with a discount badge.</p>
    </Container>
  )
}

export default FaqScreen


